import { LoadingButton } from "@mui/lab";
import { Box, Button, Modal, TextField, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useRechazarInformeMutation } from "../../redux/api/informeApi";
import { IInforme } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";
import MyToastShow from "../Layout/MyToast";
import EnvioProgramado from "./EnvioProgramado";
import dayjs from "dayjs";

type ModalRechazarInformeProps = {
    open: boolean
    onCancel: () => void
    informe?: IInforme
    onInformeRechazado: (informe: IInforme) => void
}
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    boxShadow: 24,
    p: 4,
};




const ModalRechazarInforme = ({ informe, open, onCancel, onInformeRechazado }: ModalRechazarInformeProps) => {
    const darkMode = useAppSelector(state => state.theme.darkTheme)
    
    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    const boxWidth = isMobile ? '100%' : '40rem'
    
    const [rechazarInforme] = useRechazarInformeMutation()
    const [text, setText] = useState('')
    const [loading, setLoading] = useState(false)
    
    const isInformeRejected = informe?.rejected || false
    const [selectFecha, setSelectFecha] = useState<Date | any>(dayjs().toDate().toISOString());

    const handleRechazarInforme = () => {

        setLoading(true)
        informe && rechazarInforme({ id: informe.id, rejectedReason: text, fecha: selectFecha }).unwrap().then((response) => {
            onInformeRechazado({ ...informe, rejected: !isInformeRejected })
            MyToastShow({ message: `Informe ${informe.id} ${isInformeRejected && 'des'}rechazado  con éxito`, type: 'success' })
            setText('')
        }).catch((error) => {
            MyToastShow({ message: `Error al rechazar el informe ${informe.id}`, type: 'error' })
        }).finally(() => {
            onCancel()
            setLoading(false)
        })

    }
    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`borrar-informe-${informe?.id}`}
            sx={{
                width: '100%',
            }}
        >
            <Box sx={(theme) => ({
                ...style,
                width: boxWidth,
                overflow: 'auto',
                maxHeight: '100%',
                bgcolor: darkMode ? '#232323' : '#fff',

            })}
                aria-label={`borrar-informe-${informe?.id}`}
            >

                <Typography variant='h4'> {isInformeRejected ? 'Desrechazar' : 'Rechazar'} Informe </Typography>

                <Typography variant='h6'> ¿Estás a punto de {isInformeRejected ? 'Desrechazar' : 'Rechazar'} el informe con ID: {informe?.id}? </Typography>

                {!isInformeRejected && <TextField
                    label='Motivo'
                    multiline
                    rows={4}
                    variant='outlined'
                    fullWidth
                    onChange={(e) => setText(e.target.value)}
                    value={text}
                    sx={{ mt: 2 }}
                />}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    {!isInformeRejected && <EnvioProgramado onChange={(value) => setSelectFecha(value)} value={selectFecha} />}
                    <LoadingButton
                        disabled={!isInformeRejected && text.length === 0}
                        loading={loading}
                        variant='contained'

                        color='error'

                        onClick={() => handleRechazarInforme()}>  {isInformeRejected ? 'Desrechazar' : 'Rechazar'} </LoadingButton>
                    <Button variant='contained' color='primary' sx={{ ml: 1 }} onClick={() => onCancel()}> Cerrar </Button>
                </Box>
            </Box>
        </Modal>

    );
}

export default ModalRechazarInforme;